import { defineStore } from 'pinia';
import PaymentService from '@/service/PaymentService';

export const usePaymentStore = defineStore('payment', {
  state: () => {
    return {
      quote: {}
    };
  },
  getters: {
    getQuote: (state) => state.quote
  },
  actions: {
    async submit(payload) {
      const Service = new PaymentService();
      const res = await Service.submit(payload);
      return res?.data;
    },
    updateQuote(quote) {
      this.quote = quote;
    },
    async getPaymentHistory(quoteId: string) {
      const service = new PaymentService();
      const res = await service.getPaymentHistory(quoteId);
      return res?.data;
    }
  }
});
